import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, FormattedNumber } from 'react-intl'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import styled from 'styled-components'
import { getCurrency } from 'core/utils/cultures/unit'
import RequesterStock, { requesterStockMethods } from 'core/requesters/RequesterStock'
import RequesterGlobal, { requesterGlobalMethods } from 'core/requesters/RequesterGlobal'
import Hydrator, { hydratorMethods } from 'core/hydrator'
import { Row, Col, ButtonPrimary, message } from 'core/components/ui'
import Photoswipe from 'core/components/photoswipe'
import ImagePlaceholder from 'core/components/image-placeholder'
import PageLoading from 'core/components/page-loading'
import wizardsShape from 'core/components/wizard/shapes'
import { font, greys } from 'assets/themes/theme-default'
import { stockShape } from '../shapes'
import TabsInfos from './tabs'
import ListInfos from './list-infos'
import Distributor from './distributor'

/* WS*/
/*const pointOfSales = {
  id: 256066,
  name: 'Point de vente Test 13',
  adress1: 'Avenue Gabriel Vicin',
  adress2: 'adress2',
  adress3: 'adress3',
  zipCode: '71100',
  city: 'Tournus',
  email: 'audrey.villien@bee2link.fr',
  phone1: '0630201025',
  phone2: '0385632010',
  lat: 46.5635561,
  lng: 4.8941945,
  entityName: 'entityName 1',
  DPOName1: 'Entite 1',
  DPOName2: 'GK',
  DPOEmail: 'guillaume.kick@beelink.fr'
}
*/

/** */
const Title = styled.h3`
  font-size: ${font.size.lgsm};
  color: ${props => props.theme.colors.color2.bg}};
  margin-bottom: 25px;
`
const TitleSpan = styled.span`
  font-weight: ${font.weight.base};
`

const DetailsWrapper = styled.div`
  background-color: ${greys.light4};
  padding: 30px 20px;
`

const Visuel = styled.img`
  width: 100%;
`
const TypeWrapper = styled.div`
  text-align: center;
  padding: 10px 0;
  background-color: ${props => props.theme.colors.color2.bg}};
  color: ${greys.light4}};
  text-transform: uppercase;
  margin-bottom: 15px;
`
const PriceWrapper = styled.div`
  background-color: ${props => props.theme.colors.color1.bg}};
  color: ${greys.light4}};
  width: 100%;
  padding: 20px;
  text-align: center;
  font-size: ${font.size.lgxl};
  font-weight: ${font.weight.bold};
  margin: 10px 0;
`
const ImagePlaceholderWrapper = styled.div`
  height: 600px;
  width: 100%;
`

const DistributorWrapper = styled.div`
  height: 350px;
  width: 100%;
`
const VehicleDetail = props => {
  const [loading, setLoading] = useState(false)
  const [isLoadingPointOfSales, setIsLoadingPointOfSales] = useState(false)

  const { stock, setStock, setWizards, wizards, history, intl } = props

  const { selectedVehicle } = stock

  const getPointOfSales = id => {
    setIsLoadingPointOfSales(true)

    const params = {
      id
    }

    RequesterGlobal.get(requesterGlobalMethods.GET_POINT_OF_SALES, params)
      .then(datas => {
        const { physicalPresenceSite } = datas

        const pointOfSales = Hydrator.hydrate(hydratorMethods.HYDRATE_POINTOFSALES_FROM_CAR, {
          pointOfSale: physicalPresenceSite
        })

        const newVehicle = { ...stock.selectedVehicle, pointOfSales }

        setStock({
          ...stock,
          selectedVehicle: newVehicle
        })
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setIsLoadingPointOfSales(false)
      })
  }

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_VEHICLE_DETAIL) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsStock: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const handleClickCTA = () => {
    const { price } = selectedVehicle
    const extentedStock = { ...stock, funding: { ...stock.funding, price } }
    setStock(extentedStock)
    activateNextStep()
  }

  const { typeVehicle, price, urlImage, brand, model, finishes, aImages } = selectedVehicle

  const alt = `${brand} ${model} ${finishes}`

  let sTypeVehicle

  switch (typeVehicle) {
    case 0:
      sTypeVehicle = <FormattedMessage id="stock-vehicle-detail-type-1" />
      break
    case 1:
      sTypeVehicle = <FormattedMessage id="stock-vehicle-detail-type-2" />
      break
    case 2:
      sTypeVehicle = <FormattedMessage id="stock-vehicle-detail-type-3" />
      break
    default:
      break
  }

  //const urlVisuel = `${urlImage}&width=800&height=600&bLayer=0&bCrop=0&FORMAT=2`
  const urlVisuel = urlImage || null

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.STOCK_VEHICLE_DETAIL
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    const { id } = selectedVehicle

    setLoading(true)
    RequesterStock.get(requesterStockMethods.GET_CAR, { id })
      .then(datas => {
        const { car } = datas

        const { entity, pointOfSale } = car
        const pointOfSales = Hydrator.hydrate(hydratorMethods.HYDRATE_POINTOFSALES_FROM_CAR, {
          entity,
          pointOfSale
        })

        getPointOfSales(pointOfSale.key)

        const vehicle = {
          ...car,
          colors: {
            exterior: car.externalColor,
            interior: null
          },

          pointOfSales
        }
        const extendedSelectedVehicle = Hydrator.hydrate(hydratorMethods.HYDRATE_VEHICLE, vehicle)

        setStock({
          ...stock,
          selectedVehicle: extendedSelectedVehicle
        })
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  if (selectedVehicle === null) return <PageLoading />

  return (
    <MainContentWrapper title={intl.formatMessage({ id: 'stock-vehicle-detail-view-title' })}>
      <DetailsWrapper>
        <Title>
          {brand} {model} <TitleSpan>{finishes}</TitleSpan>
        </Title>
        <Row gutter={30}>
          <Col span={14}>
            {urlImage &&
              (aImages && aImages.length > 2 ? (
                <Photoswipe aImages={aImages}>
                  <Visuel src={urlVisuel} alt={alt} />
                </Photoswipe>
              ) : (
                <Visuel src={urlVisuel} alt={alt} />
              ))}
            {!urlImage && aImages && !aImages.length > 0 && (
              <ImagePlaceholderWrapper>
                <ImagePlaceholder />
              </ImagePlaceholderWrapper>
            )}

            <TypeWrapper>{sTypeVehicle}</TypeWrapper>
            <TabsInfos loading={loading} />
          </Col>
          <Col span={10}>
            <DistributorWrapper>
              <Distributor loading={isLoadingPointOfSales} />
            </DistributorWrapper>
            {price && (
              <PriceWrapper>
                <FormattedNumber value={price} /> {getCurrency()}
              </PriceWrapper>
            )}

            <ButtonPrimary style={{ width: '100%' }} onClick={() => handleClickCTA()}>
              <FormattedMessage id="stock-vehicle-detail-cta-1" />
            </ButtonPrimary>

            <ListInfos />
          </Col>
        </Row>
      </DetailsWrapper>
    </MainContentWrapper>
  )
}

VehicleDetail.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  stock: stockShape.isRequired,
  setStock: PropTypes.func.isRequired
}

export default withRouter(injectIntl(VehicleDetail))
